/**
 * Shared exponential backoff for realtime reconnect attempts (Mercure hub
 * connect and the outer connection-init retry both use the same curve so
 * behaviour stays predictable across the platform layer).
 */
export function calcReconnectDelay(
  attempt: number,
  baseDelayMs: number,
  maxDelayMs = 30000,
): number {
  const safeAttempt = Math.max(1, attempt)
  const delay = baseDelayMs * Math.pow(2, safeAttempt - 1)
  return Math.min(delay, maxDelayMs)
}
